<template>
  <div class="correct-policyHolder section_">
    <correct-title title="投保人信息" />
    <a-row>
      <a-col :xs="24" :md="12" v-for="item in policyHolderItems" :key="item.key">
        <form-item :fieldItem="item" :editForm="batchHolder" :formItemProp="'batchHolder.' + item.key" :labelCol="labelCol" :wrapperCol="wrapperCol"></form-item>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import correctTitle from './title';
import commonOptions from '../common/options';
import formItem from '../components/formItem/index.vue';
export default {
  name: 'policyHolder',
  components: {
    correctTitle,
    formItem
  },
  inject: ['isMobile'],
  props: {
    // 投保人信息数据
    batchHolder: {
      type: Object,
      default: () => {}
    },
    // 投保人组件配置
    holderCfg: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      labelCol: { xs: 8, md: 6, lg: 4 },
      wrapperCol: { xs: 16, md: 14, lg: 16 }
    };
  },
  computed: {
    // 计算投保人组件配置数据
    policyHolderItems() {
      // 投保人组件基础表单配置数据
      let policyHolderItems = [
        { label: '保单号', key: 'policyNo' },
        { label: '保费', key: 'totalPremium' },
        { label: '投保人', key: 'name', writeable: true},
        { label: '联系地址', key: 'address', writeable: true},
        { label: '证件类型', key: 'idType', writeable: true, type: 'select', dataSource: commonOptions.idTypeOps },
        { label: '证件号码', key: 'idNumber', writeable: true},
        { label: '手机号', key: 'telephone', writeable: true },
        { label: '联系人手机号', key: 'contactsphone', writeable: true },
        { label: '联系邮箱', key: 'email', writeable: true }
      ];
      if (this.holderCfg) {
        // 如果父组件出入了投保人字段信息配置数据，则使用传入数据
        if (this.holderCfg.holderItems && this.holderCfg.holderItems.length > 0) {
          policyHolderItems = this.holderCfg.holderItems;
        } else if (this.holderCfg.dataSourceObj) {
          // 如果父组件传入了数据源配置，则使用父组件传入数据
          for (let key in this.holderCfg.dataSourceObj) {
            const opsItem = policyHolderItems.find(item => item.key === key);
            opsItem.dataSource = this.holderCfg.dataSourceObj[key];
          }
        }
      }
      return policyHolderItems;
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped></style>
